import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ArrowRight, BannerWrapper, IconButton, SimpleImage, Typography } from "@parkschannel/ui";
import Link from "next/link";
export const JoinGroupBanner = ()=>{
    return /*#__PURE__*/ _jsxs(BannerWrapper, {
        className: "bg-neutral-100",
        icon: /*#__PURE__*/ _jsx("div", {
            className: "relative w-full h-[200px]",
            children: /*#__PURE__*/ _jsx(SimpleImage, {
                src: "/media/illustrations/selfie.webp",
                alt: "Grand canyon",
                fill: true,
                className: "object-contain"
            })
        }),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                component: "h4",
                variant: "h3",
                className: "text-neutral-900 ",
                children: [
                    "Join an ",
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-primary-500",
                        children: "exclusive"
                    }),
                    " group of park explorers!"
                ]
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/utilities/guidelines",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    icon: /*#__PURE__*/ _jsx(ArrowRight, {}),
                    className: "w-full flex justify-center md:w-fit md:h-[48px]",
                    children: "Read our guidelines"
                })
            })
        ]
    });
};
